
export type ChatCategory = 'team' | 'venue' | 'general' | 'job' | 'help' | 'pl-direct';

export interface ChatCategoryInfo {
  id: ChatCategory;
  name: string;
  description: string;
  adminOnly?: boolean;
  icon: string;
  color: string;
}

export const chatCategories: ChatCategoryInfo[] = [
  {
    id: 'team',
    name: 'Team',
    description: 'Team-related discussions and coordination',
    icon: 'users',
    color: 'bg-blue-600'
  },
  {
    id: 'venue',
    name: 'Venue',
    description: 'Facility and venue-related conversations',
    icon: 'map-pin',
    color: 'bg-purple-600'
  },
  {
    id: 'general',
    name: 'General',
    description: 'General discussions and community chat',
    icon: 'message-square',
    color: 'bg-green-600'
  },
  {
    id: 'job',
    name: 'Job',
    description: 'Job opportunities and career discussions',
    icon: 'briefcase',
    color: 'bg-orange-600'
  },
  {
    id: 'help',
    name: 'Help',
    description: 'Support and assistance requests',
    icon: 'help-circle',
    color: 'bg-yellow-600'
  },
  {
    id: 'pl-direct',
    name: 'PL Direct',
    description: 'Direct admin communications',
    adminOnly: true,
    icon: 'shield',
    color: 'bg-red-600'
  }
];
